export const SignalRConstants = {
  //Ruta del Hub en el backend
  hubUrl: '/hubs/app',

  // Intervalos de reconexión en ms: 0, 2s, 4s, 8s, 16s, luego 30s cada uno hasta ~5 min.
  reconnectDelays: (() => {
    const delays: number[] = [0];
    for (let i = 1; i <= 4; i++) {
      delays.push(Math.min(1000 * Math.pow(2, i), 30000));
    }
    // Repetir cada 30s hasta ~5 min
    for (let i = 0; i < 10; i++) {
      delays.push(30000);
    }
    return delays;
  })(),

  // Base URL para el servicio genérico de jobs
  jobsApiBaseUrl: '/api/jobs',
};
